module.exports = __webpack_public_path__ + "static/snake_tree_branches_ao-93ff131f70483082c300574ec57ce84e.jpg";